<mat-drawer-container class="countable-drawer">

    <mat-drawer-content class="overflow-hidden">
        <!-- <div class="cashflow-wrapper"> -->
        <div class="page-wraper bg-gray-50">
            <div class="page-title-block align-items-start py-3 px-24">
                <div class="title-block-left flex-1  button-group flex-row">
                    <button (click)="isCashflowExpanded=false;togglePannels('C');" *ngIf="isCashflowExpanded"
                        class="btn-medium-icon button-tooltip" color="dark" mat-button mat-stroked-button
                        title="Collapse All">
                        <i class="fa-regular fa-arrow-down-left-and-arrow-up-right-to-center fs-3 text-primary"></i>
                    </button>
                    <button (click)="isCashflowExpanded=true;togglePannels('E');" *ngIf="!isCashflowExpanded"
                        class="btn-medium-icon button-tooltip" color="dark" mat-button mat-stroked-button
                        title="Expand All">
                        <i class="fa-regular fa-arrow-up-right-and-arrow-down-left-from-center fs-3 text-primary"></i>
                    </button>
                    <button (click)="refreshCashFlow(true)"
                        [disabled]="(firm?.isPaused || billing?.isPaused) || (firm?.isDeleted || firm?.isDeleteInProgress) || shortCutMenuDetails.isenglock !== 0"
                        class="btn-medium-icon button-tooltip" color="dark" mat-button mat-stroked-button
                        title="Refresh">
                        <i class="fa-regular fa-arrows-rotate"></i>
                    </button>
                </div>
                <div class="title-block-middle d-flex flex-column align-items-center flex-1 text-center">
                    <h3 class="titile">{{clientName}}</h3>
                    <h3 class="titile">{{headerNotesColumn1}}</h3>
                    <ng-container *ngIf="!isSecondColumnClicked">
                        <h6 class="title hover-action d-flex flex-row align-items-center gap-8 ps-4 text-center"
                            style="min-height:36px;">
                            {{headerNotesColumn2}} {{currentYear | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}

                            <ng-container *ngIf="shortCutMenuDetails.isenglock === 0">
                                <button
                                    (click)="focusInput();isSecondColumnClicked = true; isThirdColumnClicked = false; isOldSecondColumn = headerNotesColumn2"
                                    class="button-small-icon hover-action-item" mat-button>
                                    <i class="fa-regular fa-pen fs-15"></i>
                                </button>
                            </ng-container>
                        </h6>
                    </ng-container>
                    <ng-container *ngIf="isSecondColumnClicked">
                        <mat-form-field class="fixed-label form-field-medium icon-form-after action-2"
                            style="width: 300px">
                            <input #focusInputField (click)="$event.stopPropagation();" [(ngModel)]="headerNotesColumn2"
                                matInput type="text">


                            <div class="actions border-start" matSuffix>
                                <button (click)="saveHeaderNote()" color="success" mat-button title="Update"
                                    [disabled]="!(headerNotesColumn2.trim())"
                                    [ngClass]="[!(headerNotesColumn2.trim()) ? 'btn-disabled' : '']">
                                    <i class="fa-regular fa-check"></i>
                                </button>
                                <button (click)="isSecondColumnClicked = false; headerNotesColumn2 = isOldSecondColumn"
                                    color="cancel" mat-button title="Close">
                                    <i class="fa-regular fa-xmark clear-icon"></i>
                                </button>

                            </div>

                        </mat-form-field>
                        <h6 class="title">{{currentYear | appCountableTimeZone:'MMMM d, yyyy':'UTC'}}</h6>
                    </ng-container>
                </div>
                <div class="title-block-right flex-1"></div>
            </div>

            <div class="sorting-block d-flex flex-row align-items-end justify-content-between p-24 flex-wrap gap-20">
                <div class="sorting-block-left d-flex flex-row align-items-end form-group row-item-2">

                    <mat-form-field class="form-item fixed-label" floatLabel="always">
                        <mat-label>Entity Name</mat-label>

                        <mat-select [(value)]="clientName" [disabled]=true title="{{clientName}}">
                            <mat-option value="{{clientName}}">
                                {{clientName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="form-item ng-form-field">
                        <label>Year End Date</label>
                        <ng-select (change)="refreshCashFlow()" [(ngModel)]="selectedYearEnd" [clearOnBackspace]="false"
                            [clearable]="false" [items]="yearEndDetails" [ngModelOptions]="{standalone: true}"
                            bindLabel="acctdate" bindValue="acctyear" class="yr-dropdown" placeholder=""
                            title="{{selectedYearTitle}}">
                            <ng-template let-item="item" ng-option-tmp>
                                <div title="{{item.acctdate}}">{{item.acctdate}}</div>
                            </ng-template>
                        </ng-select>

                    </div>
                </div>

                <form class="sorting-block-right">
                    <mat-form-field class="fixed-label label-none icon-field-before" floatLabel="always">
                        <mat-label>Search</mat-label>
                        <input #searchField [(ngModel)]="searchText" [ngModelOptions]="{standalone: true}"
                            autocomplete="off" matInput placeholder="Search">
                        <span matPrefix>
                            <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                        </span>
                    </mat-form-field>
                </form>

            </div>
            @if(addOrEditRef()?.type){
            <div class="flexbox-column gap-0 p-24">
                <div class="card flexbox-row align-items-start justify-content-end gap-10 p-3 count-card">
                    <button mat-button mat-stroked-button color="dark" (click)="onCancel()"
                        class="button-medium">Cancel</button>
                    <button mat-button mat-flat-button color="primary" [disabled]="!isRowDescUnique || notACurrentYear"
                        (click)="onSave()" class="button-medium">Save</button>
                </div>
            </div>
            }

            <div class="content-block-main overflow-hidden template-block-main">
                <div [ngClass]="{'fixed-footer-enabled':isMove, 'notes-row': isHideNotesToFS}"
                    class="cashflow-container-body-grid card h-100 overflow-auto w-100 auto-scroll-container"
                    cdkScrollable id="grid">
                    <div cdkDropListGroup class="flex-table fixed-header hover-action">
                        <div class="flex-table-header fixed-top" style="min-width:1200px;" appSpin
                            [spinnerConfig]="spinnerConfig()">
                            <div class="table-left-section">
                                <p class="ft-header-cell col-drag-drop"></p>
                                <p class="ft-header-cell col-group flex-1 px-2"></p>
                            </div>
                            <p class="ft-header-cell col-cash-flow-type"></p>
                            <p class="ft-header-cell col-sub-group"></p>
                            <p class="ft-header-cell col-nfs border-start">
                                <span>Notes to FS</span>
                            </p>
                            <p class="ft-header-cell col-current flex-column gap-0 align-items-end border-start"
                                title="{{currentYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                                <span>{{currentYear | appCountableTimeZone:'MMMM d':'UTC'}}</span>
                                <span>{{currentYear | appCountableTimeZone:'yyyy':'UTC'}}</span>
                            </p>
                            <p class="ft-header-cell col-previous flex-column gap-0 align-items-end border-start"
                                title="{{previousYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                                <span>{{previousYear | appCountableTimeZone:'MMMM d':'UTC'}}</span>
                                <span>{{previousYear | appCountableTimeZone:'yyyy':'UTC'}}</span>
                            </p>
                        </div>


                        <mat-accordion #accordion="matAccordion" multi="true"
                            onscroll=" 'hasscrolls = this.scrollHeight > this.height()'" style="min-width:1200px;">
                            @for (cashflowData of cashFlowTableData; track $index; let isfirst = $first, islast
                            = $last, i=$index) {
                            <mat-expansion-panel #chapterExpansionPanel (closed)="cashflowData.isExpand = false"
                                (keydown.Space)="$event.stopImmediatePropagation();"
                                (mouseenter)="mouseEnterHandler($event, chapterExpansionPanel)"
                                (opened)="cashflowData.isExpand = true" *ngIf="cashflowData.isSection"
                                [disabled]="cashflowData.isEditable" [expanded]="cashflowData.isExpand"
                                [ngStyle]="{'border-bottom': cashflowData.id == 5 && isUnmappedLastIndex ? '1px solid #000':''}">
                                <mat-expansion-panel-header (keydown.Space)="$event.stopImmediatePropagation();"
                                    class="dragable-header first-header">
                                    <mat-panel-title (keydown.Space)="$event.stopImmediatePropagation();"
                                        [ngClass]="{'searchActive': cashflowData?.highlight}">
                                        <div class="flex-table-header">
                                            <div class="table-left-section first-header-title">
                                                <p class="ft-header-cell col-toogle">
                                                    <span class="togglable-icon">
                                                        <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                                    </span>
                                                </p>

                                                <p class="ft-header-cell py-0 px-2 flex-1">
                                                    <ng-container *ngIf="!cashflowData.isEditable">
                                                        <span class="flexbox-row gap-8" title="{{cashflowData.name}}">
                                                            <span
                                                                class="text-ellipse cashflow-data">{{cashflowData.name}}</span>
                                                            <span class="dot dot-primary dot-12"
                                                                *ngIf="getBlueDot(cashflowData, 'section')"></span>
                                                            <ng-container *ngIf="shortCutMenuDetails.isenglock === 0">
                                                                <button mat-button class="button-text hover-action-item"
                                                                    (click)="cashflowData.oldvalue = cashflowData.name;cashflowData.isEditable=true;mainGroupRename(i);"
                                                                    [disabled]="isRowEdited || notACurrentYear || workbookCashFlowUtili().isEditMainGroup">
                                                                    <i class="fa-regular fa-pen fs-15"></i>
                                                                </button>
                                                                <button mat-button
                                                                    *ngIf="cashflowData?.subGroupChildren?.length"
                                                                    [disabled]="isRowEdited || notACurrentYear || workbookCashFlowUtili().isEditMainGroup"
                                                                    #cashFlowSortMenu="matMenuTrigger"
                                                                    [matMenuTriggerFor]="sortMenu"
                                                                    (click)="workbookSort(cashflowData, i);$event.stopPropagation();"
                                                                    class="button-text hover-action-item">
                                                                    <i class="fa-solid fa-arrow-up-long fs-15"></i>
                                                                </button>
                                                            </ng-container>
                                                        </span>
                                                    </ng-container>
                                                    <ng-container *ngIf="cashflowData.isEditable">
                                                        <mat-form-field
                                                            class="fixed-label label-none form-field-medium bg-white w-50">
                                                            <input #focusInputField (keyup)="checkGroupName()"
                                                                (input)="checkInputLength($event.target.value)"
                                                                [(ngModel)]="cashflowData.name" matInput
                                                                placeholder="Enter description here" required
                                                                type="text" (click)="$event.stopPropagation()">
                                                        </mat-form-field>
                                                    </ng-container>
                                                </p>
                                            </div>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>

                                <div cdkDropList #rowLevelData="cdkDropList" [cdkDropListData]="cashflowData.rows"
                                    [cdkDragDisabled]="workbookCashFlowUtili().isDragDisabled"
                                    [cdkDropListConnectedTo]="[rowLevelData]"
                                    (cdkDropListDropped)="drop($event, cashflowData.rows)" *ngIf="!cashflowData.isCash"
                                    [cdkDropListDisabled]="workbookCashFlowUtili().isDragDisabled"
                                    class="cashflow-list-container" role="list">
                                    <!-- for the first type of section -->
                                    <ng-container *ngIf="isfirst">
                                        @for (operatingActivity of cashflowData.rows; track $index; ) {
                                        <div [ngClass]="{'searchActive': operatingActivity?.highlight}" class="ft-row"
                                            id="firstType">
                                            <div class="table-left-section">
                                                <p class="ft-cell col-drag-drop"></p>
                                                <p class="ft-cell col-group flex-1 px-2">
                                                    <span class="text-ellipse"
                                                        title="{{operatingActivity.rowName}}">{{operatingActivity.rowName}}</span>
                                                </p>
                                            </div>
                                            <p class="ft-cell col-cash-flow-type"></p>
                                            <p class="ft-cell col-sub-group"></p>
                                            <p class="ft-cell col-nfs"></p>
                                            <p class="ft-cell col-current text-end border-start"
                                                title="{{currentYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                                                <span class="text-ellipse"
                                                    title="{{showFormattedNumber(operatingActivity.currYearValue)}}">{{showFormattedNumber(operatingActivity.currYearValue)}}</span>
                                            </p>
                                            <p class="ft-cell col-previous text-end border-start"
                                                title="{{previousYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                                                <span class="text-ellipse"
                                                    title="{{showFormattedNumber(operatingActivity.prevYearValue)}}">{{showFormattedNumber(operatingActivity.prevYearValue)}}</span>
                                            </p>
                                        </div>
                                        }
                                    </ng-container>

                                    <!-- single level section  -->
                                    <ng-container *ngIf="!isfirst && cashflowData.isCash === false">
                                        @for (activity of cashflowData.rows; track $index; let j = $index) {
                                        <div class="ft-row single-level-section"
                                            [ngClass]="{'searchActive': activity?.highlight,'table-row-editable':activity.isEditable}"
                                            cdkDrag [cdkDragDisabled]="activity.isEditable">
                                            <div class="table-left-section">

                                                <p class="ft-cell col-drag-drop">
                                                    <span class="status-badge bg-primary" *ngIf="activity.isManual">
                                                        <span class="status-badge-label">MAN
                                                        </span>
                                                    </span>
                                                    <button mat-button
                                                        (mousedown)="onDragAndEditAndSort('drag', false);"
                                                        class="button-text hover-action-item cursor-grab ms-1"
                                                        [hidden]="activity.id === 0">
                                                        <i class="fa-solid fa-grip-dots-vertical"></i>
                                                    </button>
                                                </p>
                                                <div class="ft-cell flex-1 px-2 flex-nowrap">
                                                    <ng-container *ngIf="activity.isEditable">
                                                        <mat-form-field
                                                            class="form-item label-none fixed-label form-field-smaller bg-white"
                                                            floatLabel="always">
                                                            <mat-label>Description</mat-label>
                                                            <input #focusInputField
                                                                (input)="checkInputLength($event.target.value)"
                                                                (keyup)="checkRowDescription(cashflowData.rows, activity.rowName)"
                                                                (change)="onChangeNc($event,i,j)"
                                                                [(ngModel)]="activity.rowName"
                                                                [disabled]="activity.id ? (engagementData && engagementData?.rftemplateid > 0 && activity.isManual) : false"
                                                                matInput placeholder="{{activity.rowName}}" required
                                                                type="text">
                                                        </mat-form-field>
                                                    </ng-container>

                                                    <span *ngIf="!activity.isEditable"
                                                        class="text-ellipse cashflow-data" title="{{activity.rowName}}">
                                                        {{activity.rowName}}
                                                    </span>

                                                    <div *ngIf="activity.id !== 0 && shortCutMenuDetails.isenglock === 0"
                                                        class="button-group gap-8 ms-2 flex-nowrap">
                                                        <button (click)="editRow('non-cash',i,j)"
                                                            [disabled]="isRowEdited || notACurrentYear || !activity.isManual"
                                                            class="button-text hover-action-item" mat-button>
                                                            <i class="fa-regular fa-pen fs-15"></i>
                                                        </button>
                                                        <button (click)="openDeleteRowDialog(activity)"
                                                            [disabled]="isRowEdited || notACurrentYear"
                                                            class="button-text hover-action-item" mat-button>
                                                            <i class="fa-regular fa-trash-can"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="ft-cell col-cash-flow-type border-start">
                                                <ng-container *ngIf="cashflowData.id !== 9">
                                                    <mat-form-field [ngClass]="{'disabled': activity.isEditable}"
                                                        class="label-none fixed-label w-100 form-field-smaller"
                                                        floatLabel="always">
                                                        <mat-select #fcType (focus)="fcType.open()"
                                                            panelClass="fcTypeSelect"
                                                            [(ngModel)]="activity.cashFlowTypeId"
                                                            [disabled]="activity.isEditable" id="{{activity.id}}">
                                                            <mat-select-trigger>
                                                                {{activity.cashFlowName}}
                                                            </mat-select-trigger>
                                                            <mat-option
                                                                (onSelectionChange)="onCFTypeSelection(activity, cf, $event)"
                                                                *ngFor="let cf of cashFlowTypes"
                                                                [disabled]="((cf.id !== 4 && isRowEdited) || (![4,5].includes(cf.id) && !isRowEdited) || (cf.id !== 4 && activity.trialBalanceId === 0))||(shortCutMenuDetails.isenglock !== 0)"
                                                                [ngClass]="{unselectedOption:cf.id != activity.cashFlowTypeId}"
                                                                [value]="cf.id">
                                                                <span>{{cf.description}} ({{cf.name}})</span>
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </ng-container>
                                            </p>
                                            <p class="ft-cell col-sub-group border-start">
                                                <ng-container *ngIf="cashflowData.id !== 9">
                                                    <mat-form-field
                                                        class="form-item label-none fixed-label form-field-smaller bg-white"
                                                        floatLabel="always">
                                                        <input #trial (keyup)="filterTrial($event, trial.value)"
                                                            [(ngModel)]="activity.rowName"
                                                            [disabled]="!activity.isEditable || isDisabledNc"
                                                            [matMenuTriggerFor]="trialBalMenu" matInput
                                                            placeholder="Search" type="text" />
                                                    </mat-form-field>

                                                    <mat-menu #trialBalMenu="matMenu" class="trial-menu max-w-initial">
                                                        <div class="flexbox-row justify-content-end p-2">
                                                            <button mat-button color="error" class="button-text">
                                                                <i class="fa-regular fa-xmark clear-icon"></i>
                                                            </button>
                                                        </div>
                                                        <div
                                                            style="max-width: fit-content;max-height: 400px; overflow-y: auto;">
                                                            <table
                                                                *ngIf="filteredTrialBalData?.length > 0 else noDataFound"
                                                                class="mat-table table-countable">
                                                                <thead>
                                                                    <tr class="mat-header-row sticky-item">
                                                                        <th class="">Acc No.</th>
                                                                        <th class="des-column">Description</th>
                                                                        <th class="">Final</th>
                                                                        <th class="">PY1</th>
                                                                        <th class="">PY2</th>
                                                                        <th class="">CF Category</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr (click)="setTrialIdToRow(trial, activity)"
                                                                        *ngFor="let trial of filteredTrialBalData">
                                                                        <td>{{ trial.accountNumber}}</td>
                                                                        <td class="des-column">
                                                                            <span class="text-ellipse">{{
                                                                                trial.accountName }}</span>
                                                                        </td>
                                                                        <td>{{
                                                                            showFormattedNumber(trial.currYearValue)
                                                                            }}</td>
                                                                        <td>{{
                                                                            showFormattedNumber(trial.prevYearValue)
                                                                            }}</td>
                                                                        <td>{{
                                                                            showFormattedNumber(trial.prevYear2Value)
                                                                            }}</td>
                                                                        <td>{{ trial.cashFlowName }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <ng-template #noDataFound>
                                                            <div class="no-data-found">
                                                                <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg"
                                                                    alt="Icon">
                                                                <h6>No records found!</h6>
                                                            </div>
                                                        </ng-template>
                                                    </mat-menu>
                                                </ng-container>
                                            </p>
                                            <p class="ft-cell col-nfs border-start flex-nowrap gap-4 py-0">
                                                <button
                                                    [disabled]="notACurrentYear || activity.isEditable || isRowEdited || workbookCashFlowUtili().isEditMainGroup"
                                                    (click)="notesFSLinkingSelectionDialogFunc(activity)"
                                                    *ngIf="cashflowData.id !== 9" mat-button class="button-text">
                                                    <i class="fa-solid fa-plus text-priamry fs-14"></i>
                                                </button>
                                                <ng-container
                                                    *ngFor="let notes of activity.notes|sortBy let index = index; let l = count">
                                                    <button mat-button (click)="navigateToNotesToFs(notes.engNoteId)"
                                                        class="button-text" matTooltip={{notes.noteName}}
                                                        matTooltipClass="ntfs-tooltip">
                                                        <span class="text-ellipse">
                                                            {{notes.engNoteId}}
                                                        </span>
                                                        <span *ngIf="index+1 != l">,</span>
                                                    </button>
                                                </ng-container>
                                            </p>
                                            <p class="ft-cell col-current text-end border-start"
                                                title="{{currentYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                                                <span *ngIf="!activity.isEditable; else editCurYear"
                                                    class="text-ellipse"
                                                    title="{{showFormattedNumber(activity.currYearValue)}}">
                                                    {{ showFormattedNumber(activity.currYearValue) }}
                                                </span>
                                                <ng-template #editCurYear>
                                                    <mat-form-field class="form-item fixed-label form-field-smaller"
                                                        floatLabel="always">
                                                        <input (blur)="roundUpNumber(activity, 'currYearValue')"
                                                            [(ngModel)]="activity.currYearValue"
                                                            [disabled]="activity.trialBalanceId > 0" matInput
                                                            pattern="[0-9]*" type="number" />
                                                    </mat-form-field>
                                                </ng-template>
                                            </p>
                                            <p class="ft-cell col-previous text-end border-start"
                                                title="{{previousYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                                                <span *ngIf="!activity.isEditable; else editPrevYear"
                                                    class="text-ellipse"
                                                    title="{{showFormattedNumber(activity.prevYearValue)}}">
                                                    {{ showFormattedNumber(activity.prevYearValue) }}
                                                </span>
                                                <ng-template #editPrevYear>
                                                    <mat-form-field class="form-item fixed-label form-field-smaller"
                                                        floatLabel="always">
                                                        <input (blur)="roundUpNumber(activity, 'prevYearValue')"
                                                            [(ngModel)]="activity.prevYearValue"
                                                            [disabled]="activity.trialBalanceId > 0" matInput
                                                            pattern="[0-9]*" type="number" />
                                                    </mat-form-field>
                                                </ng-template>
                                            </p>
                                        </div>
                                        }
                                    </ng-container>
                                </div>
                                <!-- add row button -->
                                <ng-container *ngIf="!isfirst && [2,9].includes(cashflowData.id)">
                                    <div class="ft-row add-new-row">
                                        <div class="ft-cell flex-1">
                                            <button (click)="addRowNew('non-cash', i)"
                                                [disabled]="isRowEdited || notACurrentYear || shortCutMenuDetails.isenglock !== 0"
                                                class="button-small" color="primary" mat-button mat-flat-button>
                                                <div class="flexbox-row gap-8">
                                                    <i class="fa-solid fa-plus"></i>
                                                    <span class="button-label">Add Row</span>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </ng-container>



                                <!-- sub group for cash records -->
                                <ng-container *ngIf="cashflowData.isCash">
                                    @for (subGroup of cashflowData.subGroupChildren; track $index;
                                    let subChildIndex=$index){
                                    <mat-expansion-panel #mep="matExpansionPanel" (closed)="subGroup.isExpand = false"
                                        (keydown.Space)="$event.stopImmediatePropagation();"
                                        (opened)="subGroup.isExpand = true"
                                        [disabled]="subGroup.isEditable || subGroup?.isManual"
                                        [expanded]="subGroup.isExpand">
                                        <mat-expansion-panel-header (keydown.Space)="$event.stopImmediatePropagation();"
                                            [ngClass]="{'table-row-editable':subGroup.isEditable}"
                                            class="second-header">
                                            <mat-panel-title (keydown.Space)="$event.stopImmediatePropagation();"
                                                [ngClass]="{'searchActive': subGroup?.highlight}">
                                                <div class="flex-table-header">
                                                    <div class="table-left-section">
                                                        <span class="status-badge bg-primary"
                                                            *ngIf="subGroup?.isManual">
                                                            <span class="status-badge-label">MAN
                                                            </span>
                                                        </span>
                                                        <p class="ft-header-cell col-toogle">
                                                            @if(!subGroup?.isManual){
                                                            <span class="togglable-icon">
                                                                <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                                            </span>
                                                            }
                                                        </p>

                                                        <p class="ft-header-cell col-kebab-menu">
                                                            <!-- <span
                                                                    *ngIf="(subGroup && subGroup.isManual)">&nbsp;</span> -->

                                                            @if(!subGroup?.isManual) {
                                                            <button mat-button class="hover-action-item kebab-button"
                                                                #childAdd="matMenuTrigger"
                                                                [disabled]="isRowEdited || notACurrentYear"
                                                                [matMenuTriggerFor]="addChild"
                                                                (click)="$event.stopPropagation();">
                                                                <i class="fas fa-ellipsis-vertical"></i>
                                                            </button>
                                                            }
                                                            <mat-menu #addChild="matMenu" #beforeMenu="matMenu"
                                                                xPosition="before">
                                                                <button
                                                                    (click)="mep.open();addRowNew('cash-child', i, subChildIndex)"
                                                                    [disabled]="isRowEdited || notACurrentYear"
                                                                    mat-menu-item title="Add manual adjustment">
                                                                    <span>Add manual adjustment</span>
                                                                </button>
                                                            </mat-menu>
                                                        </p>

                                                        <p class="ft-header-cell col-group flex-1 gap-8 px-2">
                                                            <span class="text-ellipse fw-semibold cashflow-data"
                                                                *ngIf="!subGroup.isEditable"
                                                                title="{{subGroup.rowName}}">
                                                                {{subGroup.rowName}}
                                                                <span *ngIf="getBlueDot(cashflowData, 'parent')"
                                                                    class="dot-in-parent"></span>
                                                            </span>

                                                            <ng-container
                                                                *ngIf="subGroup.isEditable;else editDeleteActions"
                                                                class="pc-add-col">
                                                                <mat-form-field
                                                                    class="label-none fixed-label w-100 form-field-medium bg-white w-50"
                                                                    floatLabel="always">
                                                                    <input #focusInputField
                                                                        (input)="checkInputLength($event.target.value)"
                                                                        (keyup)="checkRowDescription(cashflowData.subGroupChildren, subGroup.rowName, subGroup, subChildIndex)"
                                                                        [(ngModel)]="subGroup.rowName"
                                                                        [disabled]="subGroup.id ? (engagementData && engagementData?.rftemplateid > 0) : false"
                                                                        matInput placeholder="Enter description here"
                                                                        required type="text"
                                                                        (click)="$event.stopPropagation()">
                                                                </mat-form-field>
                                                            </ng-container>
                                                            <ng-template #editDeleteActions>
                                                                <ng-container
                                                                    *ngIf="shortCutMenuDetails.isenglock === 0">
                                                                    <button
                                                                        (click)="editRow('cash-parent', i,subChildIndex)"
                                                                        [disabled]="isRowEdited || notACurrentYear || workbookCashFlowUtili().isEditMainGroup"
                                                                        class="button-text hover-action-item"
                                                                        mat-button>
                                                                        <i class="fa-regular fa-pen fs-15"></i>
                                                                    </button>

                                                                    <button *ngIf="subGroup.id !== 0"
                                                                        (click)="openDeleteRowDialog(subGroup)"
                                                                        [disabled]="isRowEdited || notACurrentYear"
                                                                        class="button-text hover-action-item"
                                                                        mat-button>
                                                                        <i class="fa-regular fa-trash-can"></i>
                                                                    </button>
                                                                </ng-container>
                                                            </ng-template>

                                                        </p>
                                                    </div>


                                                    <p
                                                        class="ft-header-cell col-cash-flow-type border-start py-1 mat-height">
                                                    </p>
                                                    <p
                                                        class="ft-header-cell col-sub-group border-start py-1 mat-height">
                                                    </p>
                                                    <p class="ft-header-cell col-nfs border-start flex-wrap gap-4">
                                                        <button
                                                            [disabled]="notACurrentYear || subGroup.isEditable || isRowEdited || workbookCashFlowUtili().isEditMainGroup"
                                                            (click)="notesFSLinkingSelectionDialogFunc(subGroup);$event.stopPropagation();"
                                                            mat-button class="button-text">
                                                            <i class="fa-solid fa-plus text-priamry fs-14"></i>
                                                        </button>
                                                        <ng-container
                                                            *ngFor="let notes of subGroup.notes|sortBy let index = index; let l = count">
                                                            <button mat-button class="button-text"
                                                                (click)="navigateToNotesToFs(notes.engNoteId)"
                                                                matTooltip={{notes.noteName}}
                                                                matTooltipClass="ntfs-tooltip">
                                                                <span class="w-100 flexbox-row gap-2">
                                                                    <span class="text-ellipse">
                                                                        {{notes.engNoteId}}
                                                                    </span>
                                                                    <span *ngIf="index+1 != l">,</span>
                                                                </span>
                                                            </button>
                                                        </ng-container>
                                                    </p>
                                                    <p
                                                        class="ft-header-cell col-current text-end border-start mat-height">
                                                        @if(subGroup?.isEditable && subGroup?.isManual){
                                                        <mat-form-field
                                                            class="form-item fixed-label label-none w-100 bg-white"
                                                            floatLabel="always">
                                                            <input (blur)="roundUpNumber(subGroup, 'currYearValue')"
                                                                [(ngModel)]="subGroup.currYearValue" matInput
                                                                pattern="[0-9]*" type="number"
                                                                placeholder="Current Year" />
                                                        </mat-form-field>

                                                        }@else{
                                                        <span class="fw-semibold"
                                                            title="{{showFormattedNumber(subGroup.currYearValue)}}">
                                                            {{ showFormattedNumber(subGroup.currYearValue) }}
                                                        </span>
                                                        }
                                                    </p>
                                                    <p
                                                        class="ft-header-cell col-previous text-end border-start mat-height">
                                                        @if(subGroup?.isEditable && subGroup?.isManual){
                                                        <mat-form-field class="fixed-label label-none w-100 bg-white"
                                                            floatLabel="always">
                                                            <input (blur)="roundUpNumber(subGroup, 'prevYearValue')"
                                                                [(ngModel)]="subGroup.prevYearValue" matInput
                                                                pattern="[0-9]*" type="number"
                                                                placeholder="Prev Year" />
                                                        </mat-form-field>
                                                        }@else{
                                                        <span class="fw-semibold"
                                                            title="{{showFormattedNumber(subGroup.prevYearValue)}}">
                                                            {{ showFormattedNumber(subGroup.prevYearValue) }}
                                                        </span>
                                                        }

                                                    </p>
                                                </div>
                                            </mat-panel-title>
                                        </mat-expansion-panel-header>

                                        <div cdkDropList #subGroupList="cdkDropList" [cdkDropListData]="subGroup.rows"
                                            [cdkDragDisabled]="workbookCashFlowUtili().isDragDisabled"
                                            [cdkDropListConnectedTo]="[subGroupList]"
                                            (cdkDropListDropped)="drop($event, subGroup.rows)"
                                            [cdkDropListDisabled]="workbookCashFlowUtili().isDragDisabled"
                                            class="cashflow-list-container scroll-container" role="list">
                                            @for (row of subGroup.rows; track $index; let subRowIndex = $index; ) {
                                            <div [ngClass]="{'table-row-editable':row.isEditable, 'searchActive': row?.highlight}"
                                                class="ft-row" cdkDrag (cdkDragStarted)="onDragStarted($event)"
                                                (cdkDragEnded)="onDragEnded($event)"
                                                [cdkDragDisabled]="row.isEditable || row?.isDeprecition"
                                                cdkDragBoundary=".auto-scroll-container-out">
                                                <div class="table-left-section">
                                                    <p class="ft-cell col-drag-drop">
                                                        <span class="status-badge bg-primary" *ngIf="row.isManual">
                                                            <span class="status-badge-label">MAN
                                                            </span>
                                                        </span>
                                                        <button mat-button
                                                            (mousedown)="onDragAndEditAndSort('drag', false);"
                                                            class="button-text hover-action-item cursor-grab ms-1"
                                                            [hidden]="row.id === 0">
                                                            <i class="fa-solid fa-grip-dots-vertical"></i>
                                                        </button>
                                                    </p>
                                                    <p class="ft-cell col-nfs-title py-0">
                                                        <span *ngIf="!row.isEditable">{{row.mapNo?row.mapNo:'&nbsp;'
                                                            }}</span>
                                                        <ng-container *ngIf="row.isEditable">
                                                            <mat-form-field
                                                                class="fixed-label label-none form-field-smaller"
                                                                floatLabel="always">
                                                                <mat-label>Label</mat-label>
                                                                <input matInput type="text" [(ngModel)]="row.mapNo"
                                                                    disabled
                                                                    placeholder="{{row.mapNo?row.mapNo:'&nbsp;' }}">
                                                            </mat-form-field>
                                                        </ng-container>
                                                    </p>
                                                    <p class="ft-cell flex-1 py-0 px-2 overflow-hidden">
                                                        <span *ngIf="!row.isEditable" class="text-ellipse cashflow-data"
                                                            title="{{row.rowName}}">
                                                            {{row.rowName}}
                                                        </span>

                                                        <ng-container *ngIf="row.isEditable">
                                                            <mat-form-field
                                                                class="fixed-label label-none form-field-smaller bg-white"
                                                                floatLabel="always">
                                                                <input #focusInputField
                                                                    (input)="checkInputLength($event.target.value)"
                                                                    (keyup)="checkRowDescription(subGroup.rows, row.rowName)"
                                                                    [(ngModel)]="row.rowName"
                                                                    [disabled]="row.id ? (engagementData && engagementData?.rftemplateid > 0 && row.isManual) : false"
                                                                    matInput placeholder="Enter description here"
                                                                    required type="text">
                                                            </mat-form-field>
                                                        </ng-container>

                                                        <ng-container *ngIf="row.isManual && row.id !== 0">
                                                            <div class="button-group gap-8 ms-2"
                                                                *ngIf="shortCutMenuDetails.isenglock === 0">
                                                                <button mat-button class="button-text hover-action-item"
                                                                    (click)="editRow('cash-child',i,subChildIndex,subRowIndex)"
                                                                    [disabled]="isRowEdited || notACurrentYear || shortCutMenuDetails.isenglock !== 0">
                                                                    <i class="fa-regular fa-pen fs-15"></i>
                                                                </button>
                                                                <button mat-button class="button-text hover-action-item"
                                                                    (click)="openDeleteRowDialog(row)"
                                                                    [disabled]="isRowEdited || notACurrentYear">
                                                                    <i class="fa-regular fa-trash-can"></i>
                                                                </button>
                                                            </div>
                                                        </ng-container>
                                                    </p>
                                                </div>

                                                <p class="ft-cell col-cash-flow-type border-start py-0">
                                                    <mat-form-field [ngClass]="{'disabled': row.isEditable}"
                                                        *ngIf="!row?.isDeprecition"
                                                        class="form-item label-none fixed-label w-100 form-field-smaller"
                                                        floatLabel="always">
                                                        <mat-select #mySelect [(ngModel)]="row.cashFlowTypeId"
                                                            [disabled]="row.isEditable" panelClass="fcTypeSelect">
                                                            <mat-select-trigger>
                                                                {{row.cashFlowName}}
                                                            </mat-select-trigger>
                                                            <mat-option *ngFor="let cf of cashFlowTypes"
                                                                [disabled]="(cf.id !== row.cashFlowTypeId) || isRowEdited ||shortCutMenuDetails.isenglock !== 0"
                                                                [ngClass]="{unselectedOption:cf.id != row.cashFlowTypeId}"
                                                                [value]="cf.id">
                                                                <span
                                                                    title="{{cf.description}} ({{cf.name}})">{{cf.description}}
                                                                    ({{cf.name}})</span>
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </p>
                                                <p class="ft-cell col-sub-group border-start py-0">
                                                    <mat-form-field *ngIf="!row?.isDeprecition"
                                                        class="form-item label-none fixed-label w-100 form-field-smaller"
                                                        floatLabel="always">
                                                        <mat-label>Label</mat-label>
                                                        <input [disabled]="true" [value]="subGroup.rowName" matInput
                                                            type="text" placeholder="Value" />
                                                    </mat-form-field>
                                                </p>
                                                <p class="ft-cell col-nfs border-start flex-wrap gap-4 py-0">
                                                </p>
                                                <p class="ft-cell col-current text-end border-start py-0"
                                                    title="{{currentYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                                                    <span *ngIf="!row.isEditable; else editCurYear" class="text-ellipse"
                                                        title="{{showFormattedNumber(row.currYearValue)}}">
                                                        {{ showFormattedNumber(row.currYearValue) }}
                                                    </span>
                                                    <ng-template #editCurYear>
                                                        <mat-form-field
                                                            class="form-item fixed-label label-none w-100 form-field-smaller bg-white"
                                                            floatLabel="always">
                                                            <mat-label>Edit Current Year</mat-label>
                                                            <input (blur)="roundUpNumber(row, 'currYearValue')"
                                                                [(ngModel)]="row.currYearValue" class="number-field"
                                                                matInput matInput pattern="[0-9]*" type="number" />
                                                        </mat-form-field>
                                                    </ng-template>
                                                </p>
                                                <p class="ft-cell col-previous text-end border-start py-0"
                                                    title="{{previousYear | appCountableTimeZone:'MMMM d yyyy':'UTC'}}">
                                                    <span *ngIf="!row.isEditable; else editPrevYear"
                                                        class="text-ellipse"
                                                        title="{{showFormattedNumber(row.prevYearValue)}}">
                                                        {{ showFormattedNumber(row.prevYearValue) }}
                                                    </span>
                                                    <ng-template #editPrevYear>
                                                        <mat-form-field
                                                            class="form-item fixed-label label-none w-100 form-field-smaller bg-white"
                                                            floatLabel="always">
                                                            <mat-label>Edit Prev Year</mat-label>
                                                            <input (blur)="roundUpNumber(row, 'prevYearValue')"
                                                                [(ngModel)]="row.prevYearValue" matInput
                                                                type="number" />
                                                        </mat-form-field>
                                                    </ng-template>
                                                </p>
                                            </div>
                                            }
                                        </div>
                                        <!-- add row button -->
                                        <div class="ft-row add-new-row" *ngIf="(!(subGroup && subGroup.isManual))"
                                            style="min-width:1200px;">
                                            <div class="ft-cell flex-1 cashFlow-pl">
                                                <button (click)="addRowNew('cash-child', i, subChildIndex)"
                                                    [disabled]="isRowEdited || notACurrentYear || shortCutMenuDetails.isenglock !== 0"
                                                    class="button-small" color="primary" mat-button mat-flat-button>
                                                    <div class="flexbox-row gap-8">
                                                        <i class="fa-solid fa-plus"></i>
                                                        <span class="button-label">Add Row</span>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </mat-expansion-panel>
                                    }

                                    <!-- add row button -->
                                    <div class="ft-row add-new-row" style="min-width:1200px;">
                                        <div class="table-left-section w-100 mw-100">
                                            <div class="ft-cell col-group flex-1">
                                                <button (click)="addRowNew('cash-parent', i)"
                                                    [disabled]="notACurrentYear || shortCutMenuDetails.isenglock !== 0 || isRowEdited"
                                                    class="button-small" color="secondary" mat-button mat-flat-button>
                                                    <i class="fa-solid fa-plus"></i>
                                                    Manual Entry
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- total section -->
                                    <div class="ft-footer" style="min-width:1200px;">
                                        <div class="table-left-section total-footer-title">
                                            <p class="ft-footer-cell col-group flex-1">
                                                <span class="text-ellipse fw-semibold"
                                                    title="{{cashflowData.totalName}}">
                                                    {{cashflowData.totalName}}
                                                </span>
                                            </p>
                                        </div>

                                        <p class="ft-footer-cell col-current text-end border-start">
                                            <span class="text-ellipse fw-semibold"
                                                title="{{showFormattedNumber(cashflowData.currYearTotal)}}">
                                                {{showFormattedNumber(cashflowData.currYearTotal)}}
                                            </span>
                                        </p>
                                        <p class="ft-footer-cell col-previous text-end border-start">
                                            <span class="text-ellipse fw-semibold"
                                                title="{{showFormattedNumber(cashflowData.prevYearTotal)}}">
                                                {{showFormattedNumber(cashflowData.prevYearTotal)}}
                                            </span>
                                        </p>
                                    </div>
                                </ng-container>
                            </mat-expansion-panel>

                            <!-- not a section -->
                            <ng-container *ngIf="!cashflowData.isSection">
                                <div class="ft-row cashflowDatarow" [ngClass]="{'double-line' :cashflowData.id === 8 }">
                                    <div class="table-left-section total-footer-title">
                                        <p class="ft-cell col-group flex-1">
                                            @if(cashflowData.isEditable){
                                            <mat-form-field
                                                class="fixed-label label-none form-field-medium bg-white w-50">
                                                <input #focusInputField (keyup)="checkGroupName()"
                                                    (input)="checkInputLength($event.target.value)"
                                                    [(ngModel)]="cashflowData.name" matInput
                                                    placeholder="Enter description here" required type="text"
                                                    (click)="$event.stopPropagation()">
                                            </mat-form-field>
                                            }@else{
                                            <span class="flexbox-row gap-8" *ngIf="!(cashflowData.id == 'crossCheck')">
                                                <span class="text-ellipse"
                                                    [ngClass]="{'fw-semibold' :cashflowData.id === 8 }"
                                                    title="{{cashflowData.name}}">
                                                    {{cashflowData.name}}
                                                </span>
                                                <button mat-button class="button-text hover-action-item"
                                                    (click)="cashflowData.oldvalue = cashflowData.name;cashflowData.isEditable=true;mainGroupRename(i);"
                                                    [disabled]="isRowEdited || notACurrentYear || workbookCashFlowUtili().isEditMainGroup">
                                                    <i class="fa-regular fa-pen fs-15"></i>
                                                </button>
                                            </span>

                                            }

                                        </p>
                                    </div>

                                    <p class="ft-cell col-current text-end border-start">
                                        <span class="text-ellipse"
                                            [ngClass]="{'fw-semibold' :(cashflowData.id === 8 || cashflowData.id == 'crossCheck'), 'text-error': (cashflowData.id == 'crossCheck' ? (cashflowData.currYearTotal === cashflowData.prevYearTotal ? false : true) : false)}"
                                            title="{{cashflowData.id == 'crossCheck' ? (cashflowData.currYearTotal === cashflowData.prevYearTotal ? '-' : showFormattedNumber(cashflowData.currYearTotal)) : showFormattedNumber(cashflowData.currYearTotal) }}">
                                            {{cashflowData.id == 'crossCheck' ? (cashflowData.currYearTotal ===
                                            cashflowData.prevYearTotal ? '-' :
                                            showFormattedNumber(cashflowData.currYearTotal)) :
                                            showFormattedNumber(cashflowData.currYearTotal) }}
                                        </span>
                                    </p>
                                    <p class="ft-cell col-previous text-end border-start">
                                        <span class="text-ellipse"
                                            [ngClass]="{'fw-semibold' :(cashflowData.id === 8), 'text-error': (cashflowData.id == 'crossCheck' ? (cashflowData.currYearTotal === cashflowData.prevYearTotal ? false : true) : false)}"
                                            title="{{cashflowData.id == 'crossCheck' ? (cashflowData.currYearTotal === cashflowData.prevYearTotal ? '-' : showFormattedNumber(cashflowData.prevYearTotal)) : showFormattedNumber(cashflowData.prevYearTotal)}}">
                                            {{cashflowData.id == 'crossCheck' ? (cashflowData.currYearTotal ===
                                            cashflowData.prevYearTotal ? '-' :
                                            showFormattedNumber(cashflowData.prevYearTotal)) :
                                            showFormattedNumber(cashflowData.prevYearTotal)}}
                                        </span>
                                    </p>
                                </div>
                            </ng-container>
                            }

                        </mat-accordion>

                    </div>
                </div>
            </div>

            <div *ngIf="isHideNotesToFS"
                class="mt-auto d-flex align-items-center justify-content-center bg-gray-1 py-2 px-3 hover-action">
                <ng-container *ngIf="!isFooterNoteEdited && shortCutMenuDetails.isenglock === 0">
                    <h6 class="title d-flex flex-row align-items-center gap-8" style="min-height:36px;">
                        {{footerNotes}}
                        <button (click)="editFooterNotes();" class="button-small-icon hover-action-item" mat-button>
                            <i class="fa-regular fa-pen fs-15"></i>
                        </button>
                    </h6>

                </ng-container>
                <ng-container *ngIf="isFooterNoteEdited">
                    <mat-form-field class="fixed-label form-field-medium icon-form-after action-2" style="width: 300px">
                        <input #focusInputField [(ngModel)]="footerNote" matInput type="text">
                        <div class="actions border-start" matSuffix>
                            <button (click)="saveFooterNote()" color="success" mat-button
                                [disabled]="!(footerNote.trim())"
                                [ngClass]="[!(footerNote.trim()) ? 'btn-disabled' : '']">
                                <i class="fa-regular fa-check"></i>
                            </button>
                            <button (click)="cancelEditFooterNote();" color="cancel" mat-button>
                                <i class="fa-regular fa-xmark clear-icon"></i>
                            </button>
                        </div>
                    </mat-form-field>
                </ng-container>
            </div>
        </div>
    </mat-drawer-content>

    <mat-drawer #drawer appResizableDrawer resizeDirection="left" [minWidth]="600" [maxWidth]="700"
        (resizeEvent)="onResizePanelEnd($event)" class="order-2" style="width: 600px;">
        <div class="toogle-button-block button-block-right">
            <button mat-button class="button-small-icon toogle-button" (click)="drawer.toggle()"></button>
            <div class="toogle-content d-flex">
                <h6 class="title">Preview</h6>
            </div>
        </div>
        <div class="content-block w-100">
            <cashflow-preview style="height:100%;" [selectedYearEnd]="selectedYearEnd"
                [isRefreshEvents]="isRefreshSubject.asObservable()"
                [headerFooterData]="headerFooterDataSubject.asObservable()"></cashflow-preview>
        </div>

    </mat-drawer>

</mat-drawer-container>
<!-- </div> -->

<!-- delete row popup-->
<ng-template #deleteConfirmDialog let-data>
    <div (click)="$event.stopPropagation()" class="countable-dialog" style="width: 400px;">
        <div class="dialog-header d-flex flex-column align-items-center">
            <span class="badge badge-error badge-circle icon-bordered-error">
                <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M6.5 1.5H11.5M1.5 4H16.5M14.8333 4L14.2489 12.7661C14.1612 14.0813 14.1174 14.7389 13.8333 15.2375C13.5833 15.6765 13.206 16.0294 12.7514 16.2497C12.235 16.5 11.5759 16.5 10.2578 16.5H7.74221C6.42409 16.5 5.76503 16.5 5.24861 16.2497C4.79396 16.0294 4.41674 15.6765 4.16665 15.2375C3.88259 14.7389 3.83875 14.0813 3.75107 12.7661L3.16667 4M7.33333 7.75V11.9167M10.6667 7.75V11.9167"
                        stroke="#D92D20" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.66667" />
                </svg>
            </span>
        </div>
        <div class="content dialog-body-content text-center gap-8">
            <p class="para-text">{{ data.text }}</p>
        </div>
        <div class="dialog-footer button-group w-100" mat-dialog-actions>
            <button (click)="cancelDeleteRow()" *ngIf="data.isDelete" [mat-dialog-close]="close"
                class="button-normal flex-1" color="dark" mat-button mat-stroked-button>
                Cancel
            </button>
            <button (click)="deleteRow()" *ngIf="data.isDelete" [mat-dialog-close]="close"
                class="button-normal flex-1 m-0" color="error" mat-button mat-flat-button>
                Delete
            </button>
            <button (click)="setCFFocus()" *ngIf="!data.isDelete" [mat-dialog-close]="close" color="primary" mat-button
                mat-flat-button>
                Ok
            </button>
        </div>
    </div>
</ng-template>


<!--dialog layout-->

<ng-template #notesFSLinkingDialog>
    <div class="countable-dialog template-block-main right-drawer-dialog max-w-100 w-350 mh-100">
        <div class="dialog-header p-2">
            <h4>Link Notes to {{finstatement}}</h4>
            <button aria-label="Close" class="transparent-btn close" mat-dialog-close type="button">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>
        <div class="dialog-body-content p-0">
            <div class="flexbox-column gap-8 px-2">
                <mat-form-field class="form-item fixed-label" floatLabel="always">
                    <mat-label>{{finstatement}} Item to Link:</mat-label>

                    <mat-select (ngModelChange)="changednotesLinks()" [(ngModel)]="notesSRc">
                        <div style="padding: 1rem;">
                            <ng-container *ngFor="let subgroup of cashFlowTableData" style="padding: 1rem;">
                                <ng-container
                                    *ngIf="!(subgroup.id === 1 || subgroup.id === 6 || subgroup.id === 7 || subgroup.id === 8 || subgroup.id === 9)">
                                    {{subgroup.name}}
                                    <ng-container *ngIf="subgroup?.rows && subgroup.rows.length">
                                        <mat-option *ngFor="let option of subgroup.rows" [value]="option"
                                            class="fs-items-option">
                                            {{option.rowName}}
                                        </mat-option>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="subgroup?.subGroupChildren && subgroup.subGroupChildren.length">
                                        <ng-container *ngFor="let item of subgroup.subGroupChildren">
                                            <ng-container *ngIf="item.isManualParent">
                                                <mat-option [value]="item" class="fs-items-option">
                                                    {{item.rowName }}
                                                </mat-option>
                                            </ng-container>
                                            <ng-container *ngIf="!item.isManualParent">
                                                <div style="padding: 1rem;">{{item.rowName}}

                                                    <mat-option *ngFor="let option of item.rows" [value]="option"
                                                        class="fs-items-option">
                                                        {{option.rowName }}
                                                    </mat-option>
                                                </div>
                                            </ng-container>
                                        </ng-container>

                                    </ng-container>
                                </ng-container>


                            </ng-container>
                        </div>
                    </mat-select>
                </mat-form-field>
                <form>
                    <div class="search-block gap-20">
                        <mat-form-field class="fixed-label  flex-1 icon-form-before w-100" floatLabel="always">
                            <mat-label for="">Select notes to link:</mat-label>
                            <input #searchField (keyup)="searchNotes($event.target.value)"
                                (keyup.backspace)="searchNotes($event.target.value)" [(ngModel)]="searchKeyword"
                                autocomplete="off" id="searchKeyword" matInput maxlength="20" name="searchKeyword"
                                placeholder="Search">
                            <span matPrefix>
                                <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                            </span>
                        </mat-form-field>
                    </div>
                </form>
                <mat-checkbox (change)="selectAll($event);disablegreenbutton=false;" [(ngModel)]="isSelectAll"
                    [checked]="isSelectAll" id="isSelectAll" name="selectAll">
                    <span>Select all</span>
                </mat-checkbox>
            </div>

            <div class="templates-list h-100">
                <ng-container *ngFor="let category of notes; trackBy: trackByRecords;let i=index">
                    <mat-accordion #accordion="matAccordion" *ngIf="category.notes" class="w-100" multi="true">
                        <mat-expansion-panel [expanded]="category.isExpand" [togglePosition]="'before'">
                            <mat-expansion-panel-header
                                [ngClass]="{'checked': category.is_checked == true, 'searchActive': category?.highlight}">
                                <mat-panel-title>
                                    <span class="title-content">
                                        <span class="togglable-icon">
                                            <i class="toogle-icon fa-solid fa-angle-right fs-3"></i>
                                        </span>

                                        <mat-checkbox class="label-none"
                                            (change)="is_recordChecked(i,'category');disablegreenbutton=false;"
                                            (click)="$event.stopPropagation()"
                                            [checked]="category.is_checked"></mat-checkbox>

                                        <span class="item-icon">
                                            <i class="fa-regular fa-folder-bookmark"></i>
                                        </span>
                                        <span class="item-title">{{category.engNoteId}}. {{category.name}}</span>
                                    </span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <ul class="templates-list-items">
                                <li title="{{note.engNoteId}}.{{note.name}}"
                                    *ngFor="let note of category.notes;let j=index"
                                    [ngClass]="{'checked': note.is_checked == true, 'searchActive': note?.highlight}">
                                    <mat-checkbox class="list-item-content"
                                        (change)="is_recordChecked(i,'subcategory',j);disablegreenbutton=false;"
                                        (click)="$event.stopPropagation()" [checked]="note.is_checked">
                                        <span class="flexbox-row gap-8">
                                            <span class="item-icon">
                                                <img src="/assets/images/icons/notes-icon.svg" alt="Toogle">
                                            </span>
                                            <span class="item-title">{{note.engNoteId}}.{{note.name}}</span>
                                        </span>
                                    </mat-checkbox>
                                </li>
                            </ul>
                        </mat-expansion-panel>
                    </mat-accordion>
                    <ng-container *ngIf="!category.notes">
                        <ul class="templates-list-items">
                            <li title="{{category.engNoteId}}.{{category.name}}"
                                [ngClass]="{'active': category.is_checked == true, 'searchActive': category?.highlight}">
                                <mat-checkbox class="list-item-content"
                                    (change)="is_recordChecked(i,'category');disablegreenbutton=false;"
                                    (click)="$event.stopPropagation()" [checked]="category.is_checked">
                                    <span class="flexbox-row gap-8">
                                        <span class="item-icon">
                                            <img src="/assets/images/icons/notes-icon.svg" alt="Toogle">
                                        </span>
                                        <span class="item-title">{{category.engNoteId}}.{{category.name}}</span>
                                    </span>
                                </mat-checkbox>
                            </li>
                        </ul>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div class="dialog-footer border-top p-2">
            <button (click)="saveLinkNotes()" *ngIf="(!disablegreenbutton)" [mat-dialog-close] color="primary"
                mat-button mat-flat-button class="button-medium" [disabled]="shortCutMenuDetails.isenglock !== 0">
                Link/Unlink Notes {{getCheckedNotes().length > 0 ? "(" + getCheckedNotes().length + ")" : ''}}
            </button>
            <button (click)="saveLinkNotes()"
                *ngIf="getCashflow_Notes_Link_Obj()?.notes && getCashflow_Notes_Link_Obj()?.notes?.length && disablegreenbutton "
                [disabled]="disablegreenbutton || shortCutMenuDetails.isenglock !== 0" mat-button mat-flat-button
                color="success" class="button-medium">
                Linked notes {{getCheckedNotes().length > 0 ? "(" + getCheckedNotes().length + ")" : ''}}
            </button>
        </div>
    </div>
</ng-template>


<mat-menu class="sort-menu" #sortMenu="matMenu">
    <app-workbook-sorting [sortData]="sortData" (closeMenu)="sortedData($event)"></app-workbook-sorting>
</mat-menu>

<ng-template #dragAndDropRestricted>
    <div class="countable-dialog w-400">
        <div mat-dialog-title class="dialog-header d-flex flex-column align-items-center p-0">
            <span class="badge badge-error badge-circle icon-bordered-error text-center">
                <i class="fa-regular fa-circle-info fs-16"></i>
            </span>
        </div>
        <div mat-dialog-content class="content dialog-body-content text-center gap-16 mt-2 mb-32">

            <h4 class="title text-center">Reordering items outside the group is restricted.</h4>

        </div>
        <div mat-dialog-actions class="dialog-footer button-group">
            <button [mat-dialog-close]="true" mat-button mat-flat-button color="primary" class="button-medium">Ok
            </button>
        </div>
    </div>
</ng-template>